import { createFileRoute } from "@tanstack/react-router";

// Ngày bản tin nằm trên URL: chuông và thư 22 giờ trỏ thẳng /viec-can-xem?ngay=…
type AiBriefingSearch = { ngay?: string | undefined; tab?: string | undefined };

export const Route = createFileRoute("/_app/viec-can-xem/")({
  validateSearch: (search: Record<string, unknown>): AiBriefingSearch => ({
    ngay: typeof search.ngay === "string" ? search.ngay : undefined,
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
});
